import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription, timer } from 'rxjs';
import { AuthService } from './auth.service';
import { NotificationsControllerService } from '../sdk/api/notificationsController.service';
import { NotificationsWithRelations } from '../sdk/model/notificationsWithRelations';

const REFRESH_INTERVAL_MS = 5 * 60 * 1000;

@Injectable({ providedIn: 'root' })
export class NotificationsRefreshService {
  private notificationsSubject = new BehaviorSubject<NotificationsWithRelations[]>([]);
  notifications$ = this.notificationsSubject.asObservable();
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();
  private lastRefreshSubject = new BehaviorSubject<Date | null>(null);
  lastRefresh$ = this.lastRefreshSubject.asObservable();

  private timerSub?: Subscription;
  private inFlight = false;

  constructor(
    private notificationsService: NotificationsControllerService,
    private authService: AuthService
  ) {
    this.init();
  }

  private init(): void {
    this.refreshNow();
    this.timerSub = timer(REFRESH_INTERVAL_MS, REFRESH_INTERVAL_MS).subscribe(() => {
      this.refreshNow();
    });
  }

  refreshNow(): void {
    if (this.inFlight) return;
    const currentUserId = this.authService.currentUserValue?.id;
    if (!currentUserId) return;

    this.inFlight = true;
    this.loadingSubject.next(true);
    this.notificationsService.notificationsControllerFind(
      JSON.stringify({
        order: 'id DESC',
        limit: 1000,
        skip: 0,
        where: {
          userprofileId: currentUserId,
          isDeleted: null
        }
      }) as any
    ).subscribe({
      next: (resp) => {
        this.notificationsSubject.next(resp || []);
        this.lastRefreshSubject.next(new Date());
        this.inFlight = false;
        this.loadingSubject.next(false);
      },
      error: () => {
        this.inFlight = false;
        this.loadingSubject.next(false);
      }
    });
  }

  getNotificationsSnapshot(): NotificationsWithRelations[] {
    return this.notificationsSubject.value;
  }

  getLastRefreshSnapshot(): Date | null {
    return this.lastRefreshSubject.value;
  }
}
